import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Order from '../../main/order-grid/order';

class OrderDialog extends Component {
  render() {
    if (!this.props.order) {
      return null;
    }

    return (
      <Dialog
        open={this.props.open}
        onClose={this.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Bestellung</DialogTitle>
        <DialogContent>
          <Order value={this.props.order} />
        </DialogContent>
      </Dialog>
    );
  }
}

OrderDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  order: PropTypes.object,
};

OrderDialog.defaultProps = {
  order: null,
  onDismiss: () => {},
  onAgree: () => {},
};

export default OrderDialog;
